var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMixLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1841.1 315.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Colors"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "440.55 249.86 355.07 0 0 0 0 315.62 184.11 315.62 184.11 65.75 269.59 315.62 440.55 315.62 440.55 315.61 440.55 315.62 611.51 315.62 696.99 65.75 696.99 315.62 881.1 315.62 881.1 0 526.03 0 440.55 249.86"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 920.55,
    width: 184.11,
    height: 315.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1841.1 0 1610.96 0 1486.03 124.93 1361.1 0 1130.96 0 1288.77 157.81 1130.96 315.62 1361.1 315.62 1486.03 190.68 1610.96 315.62 1841.1 315.62 1683.29 157.81 1841.1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixLogo);
export default __webpack_public_path__ + "static/media/mix-logo.27789e25c558c1843488daaa084336ab.svg";
export { ForwardRef as ReactComponent };